import React from 'react'

interface TimeSeriesIndicatorIconProps {
  x: number
  y: number
  size?: number
}

/**
 * SVG icon component that indicates an instrument has linked time series data.
 * Renders a small activity/sine wave pattern to visually mark instruments
 * with available PI datapoints.
 */
export const TimeSeriesIndicatorIcon: React.FC<
  TimeSeriesIndicatorIconProps
> = ({ x, y, size = 14 }) => {
  // Activity/zig-zag pattern path scaled to the icon size
  // Based on lucide-react Activity icon pattern
  const scale = size / 24

  return (
    <g transform={`translate(${x}, ${y})`} style={{ pointerEvents: 'none' }}>
      {/* Background circle for visibility */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={size / 2}
        fill='#0f172a'
        fillOpacity={0.85}
      />
      {/* Activity/sine wave icon */}
      <g transform={`scale(${scale})`}>
        <path
          d='M22 12h-4l-3 9L9 3l-3 9H2'
          fill='none'
          stroke='#22d3ee'
          strokeWidth={2.5}
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
    </g>
  )
}

export default TimeSeriesIndicatorIcon
